module.exports = __webpack_public_path__ + "static/media/settings-icon.016d10ab.svg";